var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalaxySvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 405,
    height: 832,
    viewBox: "0 0 405 832",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_218_338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M611 425C611 549.264 510.264 650 386 650C261.736 650 161 549.264 161 425C161 300.736 261.736 200 386 200C510.264 200 611 300.736 611 425ZM163.488 425C163.488 547.89 263.11 647.512 386 647.512C508.89 647.512 608.512 547.89 608.512 425C608.512 302.11 508.89 202.488 386 202.488C263.11 202.488 163.488 302.11 163.488 425Z",
    fill: "#737373",
    fillOpacity: 0.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_218_338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M724 428C724 603.627 581.627 746 406 746C230.373 746 88 603.627 88 428C88 252.373 230.373 110 406 110C581.627 110 724 252.373 724 428ZM90.1748 428C90.1748 602.425 231.575 743.825 406 743.825C580.425 743.825 721.825 602.425 721.825 428C721.825 253.575 580.425 112.175 406 112.175C231.575 112.175 90.1748 253.575 90.1748 428Z",
    fill: "#737373",
    fillOpacity: 0.3
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_218_338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M826 416C826 642.437 642.437 826 416 826C189.563 826 6 642.437 6 416C6 189.563 189.563 6 416 6C642.437 6 826 189.563 826 416ZM8.80402 416C8.80402 640.888 191.112 823.196 416 823.196C640.888 823.196 823.196 640.888 823.196 416C823.196 191.112 640.888 8.80402 416 8.80402C191.112 8.80402 8.80402 191.112 8.80402 416Z",
    fill: "#737373",
    fillOpacity: 0.3
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_218_338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M525 422.5C525 505.067 458.067 572 375.5 572C292.933 572 226 505.067 226 422.5C226 339.933 292.933 273 375.5 273C458.067 273 525 339.933 525 422.5ZM227.653 422.5C227.653 504.153 293.847 570.347 375.5 570.347C457.153 570.347 523.347 504.153 523.347 422.5C523.347 340.847 457.153 274.653 375.5 274.653C293.847 274.653 227.653 340.847 227.653 422.5Z",
    fill: "#737373",
    fillOpacity: 0.3
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_218_338)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 102,
    r: 8,
    fill: "#FF9900"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_218_338)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 603,
    r: 8,
    fill: "#E77C40"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_218_338)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 424,
    r: 8,
    fill: "#252B42"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_218_338)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 338,
    r: 8,
    fill: "#04236B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_218_338",
    x: 155,
    y: 194,
    width: 462,
    height: 462,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_218_338"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_218_338",
    x: 82,
    y: 104,
    width: 648,
    height: 648,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_218_338"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_218_338",
    x: 0,
    y: 0,
    width: 832,
    height: 832,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_218_338"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_218_338",
    x: 220,
    y: 267,
    width: 311,
    height: 311,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_218_338"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_218_338",
    x: 139,
    y: 88,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_218_338"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_218_338",
    x: 242,
    y: 589,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_218_338"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_218_338",
    x: 212,
    y: 410,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_218_338"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_218_338",
    x: 88,
    y: 324,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_218_338"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalaxySvg);
export default __webpack_public_path__ + "static/media/galaxySvg.64ad0ed6ca8691f169b3d3ceaf7d8627.svg";
export { ForwardRef as ReactComponent };